import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import WireDiagram from 'components/WireDetails/Diagram'
import { updateWireAction, deleteWireAction } from 'actions/entityActions'
import { notificationAction } from 'actions/notificationActions'
import { currentWireSelector, wireStartDeviceSelector, wireEndDeviceSelector } from 'selectors/components'

const mapStateToProps = state => {
  const currentWire = currentWireSelector(state)

  return {
    currentWire,
    startDevice: currentWire && wireStartDeviceSelector(state),
    endDevice: currentWire && wireEndDeviceSelector(state),
    map: state.map.ref
  }
}

class EditWire extends React.Component {
  computeBounds = overlay => {
    let bounds = new google.maps.LatLngBounds()
    overlay.getPath().getArray().forEach(latLng => bounds.extend(latLng))
    return bounds
  }

  deleteListener = _ => {
    const { currentWire: { id, locked, remove }, startDevice, endDevice, notificationAction, deleteWireAction } = this.props

    if (locked) {
      return notificationAction('Cannot delete locked cable')
    } else if (startDevice.locked) {
      if (!window.confirm(`${startDevice.name} is locked, are you sure you want to delete this cable?`)) return
    } else if (endDevice.locked) {
      if (!window.confirm(`${endDevice.name} is locked, are you sure you want to delete this cable?`)) return
    }

    remove()
    deleteWireAction(id, true)
  }

  render() {
    const { deleteListener, computeBounds, props: { currentWire, map, startDevice, endDevice, updateWireAction, classes } } = this

    if (!currentWire) return null

    const { id, locked, overlay, start } = currentWire

    return (
      <div className={classes.editWire}>
        <div className={classes.header}>
          Edit Cable
        </div>
        <div className={classes.buttonsContainer}>
          <div
            onClick={deleteListener}
            className={classes.deleteButton}
          >
            <FontAwesomeIcon icon={['far', 'trash-alt']} />
          </div>
          <div onClick={_ => map.fitBounds(computeBounds(overlay))}>
            <FontAwesomeIcon icon='map-marker-alt' />
          </div>
          <div onClick={_ => updateWireAction(id, { locked: !locked })}>
            <FontAwesomeIcon icon={locked ? 'lock' : 'unlock'} />
          </div>
        </div>
        <WireDiagram
          wire={currentWire}
          startDevice={startDevice}
          startDeviceType={start.type}
          endDevice={endDevice}
          mobile
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateWireAction, deleteWireAction, notificationAction })(injectSheet(style)(EditWire))



// WEBPACK FOOTER //
// ./src/components/BottomBar/WireDetails/index.js